import { groq } from 'next-sanity';
import { z } from 'zod';

export const SanityVideoLoop = z.object({
  _type: z.literal('videoLoop'),
  _key: z.string().optional().nullable(),
  /** Mux playback ID — preferred when present */
  playbackId: z.string().optional().nullable(),
  /** Legacy Sanity CDN MP4 URL — used when playbackId is missing */
  url: z.string().optional().nullable(),
  width: z.number(),
  height: z.number(),
  caption: z.string().optional().nullable(),
  loop: z.boolean(),
  showControls: z.boolean(),
  roundedCorners: z.boolean(),
  captionTextAlign: z.enum(['left', 'center']).optional().nullable(),
  videoPosterUrl: z.string().optional().nullable(),
  mimeType: z.string().optional().nullable(),
});
export type SanityVideoLoop = z.infer<typeof SanityVideoLoop>;

export const videoLoop = groq`{
  _type,
  caption,
  captionTextAlign,
  "loop": coalesce(loop, true),
  "showControls": coalesce(showControls, false),
  "roundedCorners": coalesce(roundedCorners, false),
  "playbackId": muxVideo.asset->playbackId,
  "videoPosterUrl": coalesce(
    videoPoster.asset->url,
    select(
      defined(muxVideo.asset->playbackId) =>
        "https://image.mux.com/" + muxVideo.asset->playbackId + "/thumbnail.jpg"
    )
  ),
  defined(_key) => {
    _key,
  },
  ...(videoFile.asset-> {
    mimeType,
    _id,
    url,
    defined(altText) => {
      'alt': altText,
    },
  }),
  // Prefer Mux track dimensions, then explicit CMS fields, then legacy file metadata
  'width': coalesce(
    muxVideo.asset->data.tracks[type == "video"][0].max_width,
    width,
    videoFile.width,
    1600
  ),
  'height': coalesce(
    muxVideo.asset->data.tracks[type == "video"][0].max_height,
    height,
    videoFile.height,
    900
  ),
}`;
